import { StrapiResult } from "@feelrobotics/strapi-sdk";
import { getSingle } from "@feelrobotics/strapi-sdk";

const PRIVACY_TYPE = "privacy";
const TERMS_TYPE = "terms";

async function getPrivacyPolicy(): Promise<StrapiResult> {
  const searchString = "fhx-privacy-policy";

  const result = await getSingle(searchString, PRIVACY_TYPE);
  result.response = {
    title: result.response["title"],
    content: result.response["content"],
  };
  return result;
}

async function getTermsAndConditions(): Promise<StrapiResult> {
  const searchString = "fhx-terms-and-condition";

  const result = await getSingle(searchString, TERMS_TYPE);
  result.response = {
    title: result.response["title"],
    content: result.response["content"],
  };
  return result;
}

export { getPrivacyPolicy, getTermsAndConditions };
